module.exports = __webpack_public_path__ + "assets/img/TLXD-10.5f7b2009.jpg";